export function automationIssueKey(reason, product) {
 if(reason==='historical_evaluation_unconfirmed')return 'olderEvaluation';
 if(reason==='evaluation_data_incomplete')return 'optionalTables';
 if(reason==='actual_table_scope_requires_review'||reason==='actual_source_incomplete')return 'tableScope';
 if(reason==='not_played_or_kickoff_passed_no_historical_recompile')return 'fixtureLifecycle';
 if(reason==='market_missing')return 'marketBasis';
 if(/statistics_incomplete|actual_statistics_missing|should_statistics_insufficient/.test(reason))return 'statisticsMissing';
 if(/PILOT_SCOPE_REQUIRES_CHRONOLOGICAL_PREFIX|REPLAY_PENDING|CHRONOLOGY_VIOLATION/.test(reason))return 'modelHistory';
 if(/INITIALIZ|historical_basis|historical_replay/.test(reason))return 'modelBasis';
 if(/AWAITING_FINAL/.test(reason))return 'awaitingResult';
 if(/evaluation_blocked_after_previous_failure/.test(reason))return 'evaluationBlocked';
 if(/RATE_LIMIT/.test(reason))return 'providerWait';
 if(/CONCURRENT|CHANGED|changed/.test(reason))return 'changedDuringRun';
 if(/PREMATCH|historical_goal_line|historical_one_x_two/.test(reason))return 'marketBasis';
 if(reason==='missing' && product==='evaluation')return 'evaluationMissing';
 if(reason==='missing' && product==='should')return 'statisticsMissing';
 if(reason==='missing' && product==='aggregates')return 'aggregateMissing';
 return 'unknownIssue';
}
